import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { OneSignal } from '@ionic-native/onesignal/ngx';
import { PushNotificationConfiguration } from './models';
import { PushNotificationsService } from './services';

@NgModule({
  imports: [CommonModule],
})
export class DomainPushNotificationsModule {
  public static forRoot(config: PushNotificationConfiguration): ModuleWithProviders {
    return {
      ngModule: DomainPushNotificationsModule,
      providers: [
        {
          provide: PushNotificationConfiguration,
          useValue: config,
        },
        PushNotificationsService,
        OneSignal,
        {
          provide: APP_INITIALIZER,
          useFactory: (pushNotificationsService: PushNotificationsService) => () => {},
          deps: [PushNotificationsService],
          multi: true,
        },
      ],
    };
  }
}
